import candidate from './candidate';

export default { candidate };
